(function () {
    'use strict';

    angular
        .module('app')
        .controller('B2bPartnersAddController', B2bPartnersAddController);

    B2bPartnersAddController.$inject = ['debug', '$stateParams', 'API', '$state', 'i18n', 'alert',];

    function B2bPartnersAddController(debug, $stateParams, API, $state, i18n, alert) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isAdding = false;
        vm.add = add;
        vm.openCampaignModal = openCampaignModal;
        vm.partner = {
            commission_type: 'percent-months'
        };
        vm.campaign = null;
        vm.loadingState = {
            'partnerIsLoading': false
        };

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var newPartner = new API.B2bPartners(vm.partner);

                var promise = newPartner.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('b2bPartners.edit', { id: response.id });
                }, function () {
                })
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }

        function openCampaignModal() {
            alert.prompt('select-campaign', { campaign: vm.campaign }).then(function (newCampaignId) {
                vm.partner.campaign_id = newCampaignId;
                vm.campaign = API.Campaign.get({ id: newCampaignId });
            }, function () {
            });
        }
    }
})();